var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessOs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "#057DCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.75H7.33333C7.01117 6.75 6.75 7.01117 6.75 7.33333V11.4167C6.75 11.7388 7.01117 12 7.33333 12H10.25C10.5722 12 10.8333 11.7388 10.8333 11.4167V7.33333C10.8333 7.01117 10.5722 6.75 10.25 6.75Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 6.75H13.7498C13.4277 6.75 13.1665 7.01117 13.1665 7.33333V9.08333C13.1665 9.4055 13.4277 9.66667 13.7498 9.66667H16.6665C16.9887 9.66667 17.2498 9.4055 17.2498 9.08333V7.33333C17.2498 7.01117 16.9887 6.75 16.6665 6.75Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 12H13.7498C13.4277 12 13.1665 12.2612 13.1665 12.5833V16.6667C13.1665 16.9888 13.4277 17.25 13.7498 17.25H16.6665C16.9887 17.25 17.2498 16.9888 17.2498 16.6667V12.5833C17.2498 12.2612 16.9887 12 16.6665 12Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14.3334H7.33333C7.01117 14.3334 6.75 14.5945 6.75 14.9167V16.6667C6.75 16.9889 7.01117 17.25 7.33333 17.25H10.25C10.5722 17.25 10.8333 16.9889 10.8333 16.6667V14.9167C10.8333 14.5945 10.5722 14.3334 10.25 14.3334Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessOs);
export default __webpack_public_path__ + "static/media/BusinessOs.18012bdd1a30c2c7dc1720593e89d609.svg";
export { ForwardRef as ReactComponent };